"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.immediateMapAction = exports.immediateEmptyMapAction = exports.immediateEmptyAction = exports.immediateAction = void 0;
function immediateAction(type, map) {
    var actionCreator = map;
    actionCreator.type = type;
    return actionCreator;
}
exports.immediateAction = immediateAction;
function immediateEmptyAction(type) {
    return immediateAction(type, function () { return ({ type: type, renderImmediate: true }); });
}
exports.immediateEmptyAction = immediateEmptyAction;
function immediateEmptyMapAction(type, payloadCreator) {
    return immediateAction(type, function () { return ({
        type: type,
        renderImmediate: true,
        payload: payloadCreator(),
    }); });
}
exports.immediateEmptyMapAction = immediateEmptyMapAction;
function immediateMapAction(type, payloadCreator) {
    return immediateAction(type, function (a) { return ({
        type: type,
        renderImmediate: true,
        payload: payloadCreator(a),
    }); });
}
exports.immediateMapAction = immediateMapAction;
